;(function () {
	const loadDeferredVideo = (deferredMedia) => {
		if (!deferredMedia || deferredMedia.hasAttribute('loaded')) return null

		const template = deferredMedia.querySelector('template')
		if (!template?.content?.firstElementChild) return null

		deferredMedia.setAttribute('loaded', true)
		const media = template.content.firstElementChild.cloneNode(true)
		deferredMedia.appendChild(media)
		return media
	}

	const getSlideMedia = (slide) => {
		const deferredMedia = slide?.querySelector('deferred-media.video-slider__media')
		if (!deferredMedia) return null

		loadDeferredVideo(deferredMedia)
		return deferredMedia.querySelector('video, iframe')
	}

	const playSlideMedia = (slide) => {
		const media = getSlideMedia(slide)
		if (!media) return

		if (media.nodeName === 'VIDEO') {
			media.muted = true
			media.playsInline = true
			const playPromise = media.play()
			if (playPromise !== undefined) {
				playPromise.catch(() => {})
			}
		}
	}

	const pauseSlideMedia = (slide) => {
		const media = slide?.querySelector('deferred-media.video-slider__media video')
		if (media) {
			media.pause()
		}
	}

	const getRealSlides = (swiper) =>
		Array.from(swiper.slides).filter((slide) => !slide.classList.contains('swiper-slide-duplicate'))

	const getClipContainer = (swiper) =>
		swiper.el.closest('.video-slider') || swiper.el.closest('.video-slider__carousel-wrap') || swiper.el

	const getVisibleRatio = (slide, container) => {
		const slideRect = slide.getBoundingClientRect()
		const containerRect = container.getBoundingClientRect()
		const overlap =
			Math.min(slideRect.right, containerRect.right) - Math.max(slideRect.left, containerRect.left)

		if (overlap <= 0 || slideRect.width <= 0) return 0

		return overlap / slideRect.width
	}

	const shouldPlaySlide = (swiper, slide, visibleRatio) => {
		if (visibleRatio >= 0.2) return true

		const realSlides = getRealSlides(swiper)
		const isFirstSlide = slide === realSlides[0]
		const isLastSlide = slide === realSlides[realSlides.length - 1]

		if (visibleRatio > 0 && isLastSlide && (swiper.isEnd || swiper.progress >= 0.99)) {
			return true
		}

		if (visibleRatio > 0 && isFirstSlide && (swiper.isBeginning || swiper.progress <= 0.01)) {
			return true
		}

		return false
	}

	const syncVideoPlayback = (swiper) => {
		if (!swiper?.el?.closest('.video-slider-section')?.querySelector('[data-video-slider-autoplay]')) {
			return
		}

		const clipContainer = getClipContainer(swiper)

		swiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) return

			const visibleRatio = getVisibleRatio(slide, clipContainer)

			if (shouldPlaySlide(swiper, slide, visibleRatio)) {
				playSlideMedia(slide)
			} else {
				pauseSlideMedia(slide)
			}
		})
	}

	const initVideoSlider = () => {
		document.querySelectorAll('.video-slider-section').forEach((section) => {
			if (section.classList.contains('slider_started')) return

			const swiperEl = section.querySelector('.video-slider__swiper')
			if (!swiperEl) return

			section.classList.add('slider_started')

			const paginationEl = section.querySelector('.product-carousel__pagination')
			const autoplayEnabled = !!section.querySelector('[data-video-slider-autoplay]')

			const swiper = new Swiper(swiperEl, {
				slidesPerView: 'auto',
				spaceBetween: 12,
				watchSlidesProgress: true,
				updateOnWindowResize: true,
				loop: swiperEl.dataset.loop === 'true',
				allowTouchMove: true,
				preloadImages: true,
				breakpoints: {
					750: {
						spaceBetween: 20,
					},
					1200: {
						slidesPerView: 5,
						spaceBetween: 20,
					},
				},
				pagination: {
					el: paginationEl,
					clickable: true,
				},
				on: {
					init: function () {
						if (autoplayEnabled) syncVideoPlayback(this)
					},
					slideChangeTransitionEnd: function () {
						if (autoplayEnabled) syncVideoPlayback(this)
					},
					transitionEnd: function () {
						if (autoplayEnabled) syncVideoPlayback(this)
					},
					touchEnd: function () {
						if (autoplayEnabled) syncVideoPlayback(this)
					},
					reachEnd: function () {
						if (!autoplayEnabled) return
						const realSlides = getRealSlides(this)
						const lastSlide = realSlides[realSlides.length - 1]
						if (lastSlide) playSlideMedia(lastSlide)
						syncVideoPlayback(this)
					},
					resize: function () {
						if (autoplayEnabled) syncVideoPlayback(this)
					},
					setTranslate: function () {
						if (!autoplayEnabled) return
						if (this.__videoSliderSyncFrame) return
						this.__videoSliderSyncFrame = requestAnimationFrame(() => {
							this.__videoSliderSyncFrame = null
							syncVideoPlayback(this)
						})
					},
				},
			})
		})
	}

	document.addEventListener('DOMContentLoaded', initVideoSlider)
	document.addEventListener('shopify:section:load', initVideoSlider)
	document.addEventListener('shopify:section:unload', () => {
		document.querySelectorAll('.video-slider-section.slider_started').forEach((section) => {
			section.classList.remove('slider_started')
		})
	})

	initVideoSlider()
})()
